import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IPermPostJobAddInterviewsClickedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Add Interviews" button on the post-submission popup
 * Event: dental_portal:perm_post_job:add_interviews_clicked
 */
export function firePermPostJobAddInterviewsClicked(
  payload: IPermPostJobAddInterviewsClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:add_interviews_clicked', {
    posting_id: payload.postingId,
  });
}